import { useTranslation } from 'next-i18next'
import React from 'react'

import type { CustomError } from '@front/type/api'

type ErrorMapping = Record<number, string>

export const useErrorMessage = (
  customErrorMapping: ErrorMapping = {},
): ((error: CustomError) => string) => {
  const { t } = useTranslation('main.common')

  const defaultErrorMapping: ErrorMapping = React.useMemo(
    () => ({
      503: t('errors.service_unavailable'),
    }),
    [t],
  )

  return React.useCallback(
    (error: CustomError) => {
      const errorMapping = { ...defaultErrorMapping, ...customErrorMapping }

      return errorMapping[error.statusCode] ?? t('errors.unknown')
    },
    [customErrorMapping, defaultErrorMapping, t],
  )
}
